<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="tags" /> Danh sách cơ quan ban hành
        </span>
        <a-input
          placeholder="Tìm cơ quan ban hành theo tên..."
          style="width: 350px; max-width: 100%; margin-right: 5px;"
          @change="onFilter"
          v-model="filter.query"
        />
        <a-button-group style="margin-right: 5px;">
          <a-button
            @click="onChangeStatusFilter()"
            :type="!filter.status ? 'primary' : ''"
            >Tất cả
          </a-button>
          <a-button
            @click="onChangeStatusFilter('ACTIVE')"
            :type="filter.status === 'ACTIVE' ? 'primary' : ''"
          >
            Đang hoạt động
          </a-button>
          <a-button
            @click="onChangeStatusFilter('DEACTIVE')"
            :type="filter.status === 'DEACTIVE' ? 'primary' : ''"
          >
            Ngừng hoạt động
          </a-button>
        </a-button-group>
        <a-button
          slot="extra"
          type="primary"
          @click="() => (visibleAdd = true)"
        >
          <a-icon type="plus" /> Thêm
        </a-button>
      </div>

      <a-table
        :columns="columnsAllDocumentAgencyIssued"
        :data-source="documentAgencyIssueds"
        size="small"
        :loading="loadingList"
        rowKey="id"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            this.currentPage = page;
          },
          pageSize: limit,
        }"
      >
        <div slot="footer">
          <a-button
            :loading="loadingList"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Tải thêm
          </a-button>
        </div>
        <div slot="stt" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>

        <span slot="status" slot-scope="text">
          <p v-if="text === 'ACTIVE'">
            <a-icon type="check" style="marginleft: 5px; color: #52c419;" />
          </p>
        </span>
        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="updatedAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="action" style="float: right;" slot-scope="text, record">
          <a-button @click="collapseVisibleEdit(record.id)">
            <a-icon title="Chỉnh sửa" type="edit" /> Chỉnh sửa
          </a-button>
        </span>
      </a-table>

      <a-drawer
        v-if="visibleEdit"
        title="Chỉnh sửa"
        placement="right"
        :visible="visibleEdit"
        @close="() => (visibleEdit = false)"
        :width="450"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <EditDocumentAgencyIssued
          :idDocumentAgencyIssued="idDocumentAgencyIssued"
          :close="() => (visibleEdit = false)"
          :refreshAfterUpdated="refreshAfterUpdated"
          :refreshAfterDeleted="refreshAfterDeleted"
        />
      </a-drawer>

      <a-drawer
        v-if="visibleAdd"
        title="Thêm mới"
        placement="right"
        :visible="visibleAdd"
        @close="() => (visibleAdd = false)"
        :width="450"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <AddDocumentAgencyIssued
          :close="() => (visibleAdd = false)"
          :refreshAfterCreated="refreshAfterCreated"
        />
      </a-drawer>
    </a-card>
  </div>
</template>
<script>
import { columnsAllDocumentAgencyIssued } from "./constant/column";
import AddDocumentAgencyIssued from "./components/addDocumentAgencyIssued";
import EditDocumentAgencyIssued from "./components/editDocumentAgencyIssued";
import query from "./constant/query";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";
import codeBenefit2Title from "./services/codeBenefit2Title";
import debounce from "lodash/debounce";
const limit = 10;
const startPage = 1;
const defaultFilter = { query: "", status: "ACTIVE" };
export default {
  components: {
    AddDocumentAgencyIssued,
    EditDocumentAgencyIssued,
  },
  data() {
    this.onFilter = debounce(this.onFilter, 500);
    return {
      limit,
      visibleEdit: false,
      visibleDetail: false,
      visibleAdd: false,
      columnsAllDocumentAgencyIssued,
      loadingList: true,
      documentAgencyIssueds: [],
      idDocumentAgencyIssued: "",
      filter: defaultFilter,
      currentPage: startPage,
      totalPage: startPage,
      isPagination: true,
    };
  },
  methods: {
    codeBenefit2Title,
    onGetAllDocumentAgencyIssued(flag) {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getAllDocumentAgencyIssued,
          fetchPolicy: "no-cache",
          variables: {
            limit,
            query: this.filter.query,
            page: this.totalPage,
            status: this.filter.status,
          },
        })
        .then(({ data }) => {
          this.loadingList = false;
          if (data?.getAllDocumentAgencyIssued?.length >= 0) {
            if (flag === "FILTER") {
              this.documentAgencyIssueds = [...data.getAllDocumentAgencyIssued];
            } else if (flag === "PAGINATION") {
              this.documentAgencyIssueds = this.documentAgencyIssueds.concat([
                ...data.getAllDocumentAgencyIssued,
              ]);
            } else {
              this.documentAgencyIssueds = [...data.getAllDocumentAgencyIssued];
            }
            // check is pagniation
            if (data.getAllDocumentAgencyIssued.length < limit) {
              this.isPagination = false;
            } else {
              this.isPagination = true;
            }
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Lấy danh sách cơ quan ban hành không thành công!",
          });
          console.log("Lấy danh sách cơ quan ban hành không thành công", err);
        });
    },
    collapseVisibleDetail(id) {
      if (id) {
        this.idDocumentAgencyIssued = id;
        this.visibleDetail = true;
      } else {
        this.idDocumentAgencyIssued = "";
        this.visibleDetail = false;
      }
    },
    collapseVisibleEdit(id) {
      if (id) {
        this.idDocumentAgencyIssued = id;
        this.visibleEdit = true;
      } else {
        this.idDocumentAgencyIssued = "";
        this.visibleEdit = false;
      }
    },
    onFilter() {
      this.currentPage = startPage;
      this.totalPage = startPage;
      this.onGetAllDocumentAgencyIssued("FILTER");
    },
    refreshAfterUpdated(item) {
      this.documentAgencyIssueds = updateForUpdated(
        this.documentAgencyIssueds,
        item
      );
    },
    refreshAfterDeleted(item) {
      this.documentAgencyIssueds = updateForDeleted(
        this.documentAgencyIssueds,
        item
      );
    },
    refreshAfterCreated(item) {
      this.documentAgencyIssueds = updateForCreated({
        list: this.documentAgencyIssueds,
        item,
        limit,
        currentPage: this.currentPage,
      });
    },
    onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.onGetAllDocumentAgencyIssued("PAGINATION");
      }
    },
    onChangeStatusFilter(status) {
      this.$set(this.filter, "status", status || undefined);
      this.onFilter();
    },
  },
  created() {
    this.onGetAllDocumentAgencyIssued();
  },
};
</script>
<style lang="css" scoped></style>
